import { render, staticRenderFns } from "./CCLogo.vue?vue&type=template&id=ffff0b36&"
import script from "./CCLogo.vue?vue&type=script&lang=ts&"
export * from "./CCLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports